import { render, staticRenderFns } from "./onurairaktarim.vue?vue&type=template&id=3f6c2b3c"
import script from "./onurairaktarim.vue?vue&type=script&lang=js"
export * from "./onurairaktarim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports